import { mapGetters } from "vuex"
import { isEqual, extend } from "lodash"

const templatable = {
    mounted () {
        this.reset_current_template()
    },
    methods: {
        template_save () {
            let template_data = extend({}, this.current_template)
            if(this.template_to_clone) {
                template_data = extend({}, this.template_to_clone)
                template_data.id = 0
                this.template_to_clone = null
            } else {
                template_data.content = this.new_template_content()
            }

            let dispatch = "CREATE_RECORD"
            template_data.entity = this.entity
            if(!template_data.category) template_data.category = this.template_category
            if(template_data.id) dispatch = "RECORD_SAVE"

            this.$store.dispatch(dispatch, {
                entity: "user_preference",
                id: template_data.id,
                data: template_data,
                silent: true
            }).then(record => {
                if(!record || record.id) {
                    if(record.id) this.template_load(record, true)
                } else this.$error(record.message)
            }).catch(error => {
                this.$error(error.message)
            })
        },
        template_load (template) {
            this.current_template = extend({}, template)
            this.template_load_ui()
            this.picking_template = false
        },
        template_clone (template) {
            this.template_to_clone = extend({}, template)
            this.template_to_clone.id = 0
        },
        reset_current_template () {
            this.current_template = {
                id: 0,
                name: "",
                content: this.new_template_content()
            }
        },
        template_load_ui () {
            // *** should be overriden...
        },
        new_template_content () {
            // *** should be overriden...
            return this.current_template.content
        },
        template_editor_close () {
            this.reset_current_template()
        },
        template_editor_save () {
            this.template_save(this.new_template_content())
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_user_preferences () {
            return this.entity_records("user_preference")
        },
        preferences () {
            return Object.values(this.raw_user_preferences)
        },
        template_savable () {
            return !isEqual(this.current_template.content, this.new_template_content())
        },
        template_dirty () {
            return !!this.current_template.id && this.template_savable
        },
        templates () {
            return this.preferences.filter(preference => {
                return (preference.category === this.template_category) && (preference.entity === this.entity)
            })
        }
    },
    data () {
        return {
            current_template: {},
            template_to_clone: null,
            picking_template: false,
            template_category: "export-columns"
        }
    }
}

export default templatable
